import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
import React, { useEffect, useRef, useState } from "react";
import Typewriter from "typewriter-effect";




const NewsletterBanner: React.FC = () => {
const [image, setImage] = useState<any | null>(null);
const [data, setdata] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        /* -------- Banner API -------- */
        const bannerRes = await fetch(
          `${API_BASE_CMS}/jsonapi/node/media_news_page?include=field_featured_image.field_media_image`
        );
        const bannerJson = await bannerRes.json();
    
        const node = bannerJson.data[0]; // single object
        const included = bannerJson.included || [];
        const getImageFromMedia = (mediaId?: string) => {
            if (!mediaId) return { url: null, alt: null };

            const media = included.find(
            (inc: any) =>
                (inc.type === "media--image" || inc.type === "media--svg_image") &&
                inc.id === mediaId
            );

            if (!media) return { url: null, alt: null };

            const imageField =
            media.relationships?.field_media_image?.data ||
            media.relationships?.field_media_svg_image?.data;

            if (!imageField?.id) return { url: null, alt: null };

            const file = included.find(
            (inc: any) => inc.type === "file--file" && inc.id === imageField.id
            );

            const fileUrl = file?.attributes?.uri?.url
            ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
            : null;

            const altText = imageField?.meta?.alt || media?.attributes?.name || "";

            return {
            url: fileUrl,
            alt: altText,
            };
        };
        const Image = node.relationships?.field_featured_image?.data?.id ?? "";  
        setImage(getImageFromMedia(Image));
        setdata(node);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);



//console.log(data,image);
    if (!data) return null;
const banner  =image ? image?.url : "assets/img/media-banner.png";

  const cleanHtml =
    data?.attributes?.field_decription?.value
      ? data?.attributes?.field_decription?.value.replace(/<[^>]*>/g, "").replace(/&amp;/g, "&") 
      : "Insights, Announcements & Milestones";
  //console.log(data?.attributes?.field_decription?.value);
return(
<div
    className="page-header"
    style={{ backgroundImage: `url(${banner})` }}
    >
        <div className="container py-5">
            <h2 className="display-3 text-white py-5 mb-3  text-center" data-wow-delay="0.2s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
              {cleanHtml}
               {/* <Typewriter
            key={cleanHtml}
            onInit={(typewriter: any) => {
              typewriter.typeString(cleanHtml).start();
            }}
            options={{
              delay: 100,
              cursor: "",
            }}
          /> */}
            </h2>
        </div>
    </div>
);
};


export default NewsletterBanner;
